import script from "./AppNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./AppNavigation.vue?vue&type=style&index=0&id=2be33cfe&lang=scss"

const __exports__ = script;

export default __exports__